"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="call-to-action" ref={ref} className={`w-full bg-secondary py-16 md:py-20 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            Find the perfect placement.
          </h2>
          <Link to="#" className="shrink-0">
            <Button size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover hover:-translate-y-1 hover:shadow-medium active:bg-accent-active active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-6 text-base font-semibold rounded-lg shadow-soft">
              Get in touch
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}